import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKgExpand = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m21 3-7 7m0-7h7v7M3 21l7-7m-7 0v7h7"
	})
});
export default SvgKgExpand;
